var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSerenade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 142,
    viewBox: "0 0 128 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.4602 0.0310813C66.1511 0.154207 61.842 0.64671 57.6068 1.50859C26.8029 7.76339 3.90303 32.1915 0.406494 63.5148C-3.09003 94.8626 16.2147 133.106 48.8901 140.419C64.2797 143.866 81.196 139.606 93.163 129.313C106.189 118.084 112.616 101.216 118.525 85.0618C123.401 71.7642 128.35 58.0727 127.981 43.9132C127.168 13.4272 97.9154 -0.756924 70.4602 0.0310813Z",
    fill: "url(#paint0_radial)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.6091 29.4912C83.1418 29.4976 85.1898 31.5561 85.1836 34.089L85.1225 58.7019C85.1162 61.2348 83.0579 63.2831 80.5251 63.2768C77.9923 63.2705 75.9442 61.2121 75.9505 58.6792L76.0116 34.0661C76.018 31.5332 78.0763 29.485 80.6091 29.4912ZM94.2172 37.012C96.7499 37.02 98.7966 39.0799 98.7884 41.6129L98.7579 51.1828C98.7498 53.7157 96.6901 55.7626 94.1573 55.7544C91.6245 55.7464 89.5779 53.6864 89.586 51.1535L89.6166 41.5835C89.6246 39.0505 91.6844 37.0038 94.2172 37.012ZM66.4017 46.4609C68.9343 46.4723 70.9783 48.5348 70.967 51.0677L70.7835 91.9773C70.7722 94.5101 68.7098 96.5542 66.177 96.5429C63.6444 96.5315 61.6004 94.469 61.6117 91.9361L61.7952 51.0265C61.8065 48.4937 63.8689 46.4496 66.4017 46.4609ZM52.0558 79.7251C54.5884 79.7157 56.6493 81.7614 56.6587 84.2943L56.7505 108.938C56.7598 111.471 54.7143 113.532 52.1816 113.541C49.6488 113.551 47.588 111.505 47.5785 108.972L47.4869 84.3284C47.4775 81.7955 49.523 79.7345 52.0558 79.7251ZM38.4837 87.275C41.0164 87.267 43.0762 89.3137 43.0843 91.8466L43.115 101.386C43.123 103.919 41.0764 105.979 38.5436 105.987C36.0108 105.995 33.9512 103.948 33.943 101.415L33.9124 91.876C33.9043 89.3431 35.9509 87.2832 38.4837 87.275Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-9.17956 109.374) scale(198.195 198.209)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0103967,
    stopColor: "#C5D1E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14061,
    stopColor: "#82C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385412,
    stopColor: "#A46DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625005,
    stopColor: "#FF8488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791679,
    stopColor: "#EEC14C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerenade);
export default __webpack_public_path__ + "static/media/serenade.b7565cec.svg";
export { ForwardRef as ReactComponent };